// Product Card Size Selector
document.addEventListener('DOMContentLoaded', function() {
  // Handle size box clicks
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('product-card__size-box') && !e.target.disabled) {
      const sizeBox = e.target;
      const variantId = sizeBox.getAttribute('data-variant-id');
      const productCard = sizeBox.closest('.product-card');

      if (!productCard || !variantId) return;

      // Remove selected class from all size boxes in this product card
      const allSizeBoxes = productCard.querySelectorAll('.product-card__size-box');
      allSizeBoxes.forEach(box => box.classList.remove('selected'));

      // Add selected class to clicked size box
      sizeBox.classList.add('selected');

      // Update the hidden variant ID input
      const variantInput = productCard.querySelector('.product-card-variant-id');
      if (variantInput) {
        variantInput.value = variantId;
      }

      // Enable the add to cart button if it was disabled
      const addToCartBtn = productCard.querySelector('.quick-add__submit');
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('aria-disabled');
      }
    }
  });

  // Auto-select first available size on page load
  document.querySelectorAll('.product-card__sizes').forEach(function(sizesContainer) {
    const firstAvailableSize = sizesContainer.querySelector('.product-card__size-box:not(:disabled)');
    if (firstAvailableSize) {
      firstAvailableSize.click();
    }
  });
});
